export default {
  setRelatedCourses(state, relatedCourses) {
    state.relatedCourses = relatedCourses;
  },
  setGroups(state, groups) {
    state.groups = groups;
  }
};
